var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDogOrigamiPaperSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.34,31.38l-3.39,4.94-9.02-4.7c-.65-.33-1.44-.08-1.78,.56-.2,.38-.2,.84,0,1.22l5.31,10.28c.35,.68,.81,1.31,1.35,1.86l12.54,12.66c.78,.79,2.03,.81,2.84,.06l6.95-6.45,9.31,6.63c.36,.26,.78,.38,1.19,.38,.61,0,1.22-.28,1.62-.81l5.85-7.69c.53-.69,.82-1.55,.82-2.42V27.6l6.92-10.19c.47-.69,.75-1.5,.81-2.33l.33-4.51c.07-.94-.28-1.85-.97-2.5l-2.47-2.34c-.25-.25-.57-.42-.92-.5h0c-.71-.16-1.44,.08-1.91,.63l-2.69,3.12-1.3,.08-3.21-2.09c-.72-.46-1.55-.71-2.4-.71h-6.05c-.94,0-1.83,.42-2.42,1.15l-3.59,4.43c-.49,.61-.88,1.29-1.14,2.03l-4.32,12.16c-.15,.43-.13,.9,.07,1.31s.54,.72,.97,.88c.18,.07,.38,.1,.57,.1h3.82v1.79h-11.3c-.96,.01-1.86,.48-2.4,1.28Zm-11.42,3.01l6.9,3.59-2.87,4.19-4.02-7.78Zm27.13-4.31l9,10.87-8.98,7.44-.02-17.29h0v-1.02Zm15.89,16.05l-14.77-17.83h14.77v17.83Zm-6.32,10.67l-8.91-6.35,9.62-7.96,5.29,6.38c-.04,.07-.03,.17-.08,.23l-5.91,7.7ZM57.99,10.56l-.27,3.7-5.18-3.37,5.45-.33Zm-1.28-1.93l-2.9,.18,1.39-1.61,1.51,1.43Zm-19.51,.04c.21-.26,.53-.41,.87-.41h6.05c.47,0,.92,.13,1.31,.39l11.77,7.65-6.5,9.57-17.07-12.78,3.57-4.41Zm-8.58,17.66l4.07-11.46,15.25,11.42-19.32,.03Zm3.43,5.78l.02,17.98-7.29,6.71-12.54-12.66s-.07-.11-.11-.15l7.86-11.47c.17-.25,.45-.4,.75-.4h11.3Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "ag"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "ah"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "ai"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "aj"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "ak"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "al"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "am"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "an"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "ao"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "ap"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "aq"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "ar"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "as"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "at"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "au"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "av"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "aw"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "ax"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogOrigamiPaperSvgrepoCom);
export default __webpack_public_path__ + "static/media/dog-origami-paper-svgrepo-com.7400f91e0001c6ee3938ffcc95c14a0c.svg";
export { ForwardRef as ReactComponent };